"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./style.scss");
const Icon = (props) => {
    const { icon, className = '', onClick, id, dataStopProp, onMouseOver } = props;
    const handleOnClick = (event) => {
        if (onClick)
            onClick(event);
    };
    const handleMouseOver = (event) => {
        if (onMouseOver)
            onMouseOver(event);
    };
    return ((0, jsx_runtime_1.jsx)("span", { "data-stop-prop": dataStopProp, className: `kangda__icon_${icon} ${className}`, onMouseOver: handleMouseOver, onClick: handleOnClick, id: id }));
};
exports.default = Icon;
